import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import allowNumbersOnly, { } from '../../CommonUtils/CommonValidations';
export default function AffiliationQuestionsSection4() {
    const user_id = sessionStorage.getItem('user_id');
    const [tabledata, settabledata] = useState([])

    const [questiondef4, setquestiomdef4] = useState([]);
    function GetDeficiency4() {
        let url = config?.url?.API_URL + "getAfflQ4DeficiencyDetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setquestiomdef4(res?.data?.getAffiliationQuestions4Details)
                res?.data?.getAfflQ4DeficiencyDetails?.forEach((data, i) => {
                    AffiliationQuestions4Formik.setFieldValue(`defCdc[${i}].ffcaStatusOfDeficiency`, data?.ffca_status_of_deficiency?.toString() ?? '');
                    AffiliationQuestions4Formik.setFieldValue(`defCdc[${i}].ffcaDeficiencyRemarks`, data?.ffca_deficiency_remarks ?? '');
                    AffiliationQuestions4Formik.setFieldValue(`defCdc[${i}].slNo`, data?.sl_no);


                })
            }
            else {
                console.log(" No Data  Found ")
            }
        })
    }
    const AffQuestion4validation = Yup.object({
        defCdc: Yup.array().when('studentdetails', {
            is: (studentdetails) => studentdetails.length > 0,
            then: Yup.array().of(
                Yup.object().shape({
                    ffcaStatusOfDeficiency: Yup.string().required('This field is required').nullable(),
                    ffcaDeficiencyRemarks: Yup.string().required('This field is required').nullable(),
                })
            ),
            otherwise: Yup.array().nullable(),
        }),

        colgFacultyEduQuali: Yup.string().required(ERROR_MSG).nullable(),
        colgFaculExperQuali: Yup.string().required(ERROR_MSG).nullable(),
        colgHavingFacultAsPerStrength: Yup.string().required(ERROR_MSG).nullable(),
        colgHavingFacultTeachAllExisCoursesAndCombinat: Yup.string().required(ERROR_MSG).nullable(),
        colgHasPrinciAsperQuali: Yup.string().required(ERROR_MSG).nullable(),
        facultyDeficiencyDiscrepancies: Yup.string().required(ERROR_MSG).nullable(),
        colgHavingProfessionalCourses: Yup.string().required(ERROR_MSG).nullable(),
        ratioProfUnivNorms: Yup.string().when('colgHavingProfessionalCourses', {
            is: 1,
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string(),
        }),
        actualRatioProfInTheCollege: Yup.string().when('colgHavingProfessionalCourses', {
            is: 1,
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string(),
        }),
        colgPlacementCell: Yup.string().required(ERROR_MSG).nullable(),
        colgAdeqStaffInPlacementCell: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmCorpusFunds: Yup.string().required(ERROR_MSG).nullable(),
        colgFdrCorpusFundsValidOndate: Yup.string().required(ERROR_MSG).nullable(),
        colgAffiliaFeeDueToColg: Yup.string().required(ERROR_MSG).nullable(),
        colgMaintainingHygenEnvin: Yup.string().required(ERROR_MSG).nullable(),
        colgProvHygenDrinkingWater: Yup.string().required(ERROR_MSG).nullable(),
        colgProvAdequeteSafeElecEquip: Yup.string().required(ERROR_MSG).nullable(),
        colgHasProperRoad: Yup.string().required(ERROR_MSG).nullable(),
        colgAreaIsSuitableForEduInstitu: Yup.string().required(ERROR_MSG).nullable(),
        colgAreaEarmarkedAccessCirculationArea: Yup.string().required(ERROR_MSG).nullable(),
        colgProvOtherAment: Yup.string().required(ERROR_MSG).nullable(),
        otherDescremencies: Yup.string().required(ERROR_MSG).nullable(),
    });
    const AffiliationQuestions4Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            defCdc: [{
                slNo: "",
                ffcaStatusOfDeficiency: "",
                ffcaDeficiencyRemarks: "",
            }],

            studentdetails: [],

            colgFacultyEduQuali: "",
            colgFaculExperQuali: "",
            colgHavingFacultAsPerStrength: "",
            colgHavingFacultTeachAllExisCoursesAndCombinat: "",
            colgHasPrinciAsperQuali: "",
            facultyDeficiencyDiscrepancies: "",
            colgHavingProfessionalCourses: "",
            ratioProfUnivNorms: "",
            actualRatioProfInTheCollege: "",
            colgPlacementCell: "",
            colgAdeqStaffInPlacementCell: "",
            colgSubmCorpusFunds: "",
            colgFdrCorpusFundsValidOndate: "",
            colgAffiliaFeeDueToColg: "",
            colgMaintainingHygenEnvin: "",
            colgProvHygenDrinkingWater: "",
            colgProvAdequeteSafeElecEquip: "",
            colgHasProperRoad: "",
            colgAreaIsSuitableForEduInstitu: "",
            colgAreaEarmarkedAccessCirculationArea: "",
            colgProvOtherAment: "",
            otherDescremencies: "",
        },
        validationSchema: AffQuestion4validation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliationQuestions4details`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc);
                            GetQuestionsubmited4();
                            GetDeficiency4();
                        }
                        else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {

                    console.log('Submission canceled');
                }
            });

        },
    })
    function GetDeficineces() {
        let url = config?.url?.API_URL + "getAfflRenew";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                settabledata(res?.data?.afflRenew)
                AffiliationQuestions4Formik?.setFieldValue("studentdetails", res?.data?.afflRenew)
            }
            else {
                settabledata([])
                AffiliationQuestions4Formik?.setFieldValue('studentdetails', []);

            }

        })
    }

    function GetQuestionsubmited4() {
        let url = config?.url?.API_URL + "getAffiliationQuestions4Details";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                AffiliationQuestions4Formik?.setFieldValue(`colgFacultyEduQuali`, res?.data?.getAffiliationQuestions4Details[0]?.colg_faculty_edu_quali);
                AffiliationQuestions4Formik?.setFieldValue(`colgFaculExperQuali`, res?.data?.getAffiliationQuestions4Details[0]?.colg_facul_exper_quali);
                AffiliationQuestions4Formik?.setFieldValue(`colgHavingFacultAsPerStrength`, res?.data?.getAffiliationQuestions4Details[0]?.colg_having_facult_as_per_strength);
                AffiliationQuestions4Formik?.setFieldValue(`colgHavingFacultTeachAllExisCoursesAndCombinat`, res?.data?.getAffiliationQuestions4Details[0]?.colg_having_facult_teach_all_exis_courses_and_combinat);
                AffiliationQuestions4Formik?.setFieldValue(`colgHasPrinciAsperQuali`, res?.data?.getAffiliationQuestions4Details[0]?.colg_has_princi_asper_quali);
                AffiliationQuestions4Formik?.setFieldValue(`facultyDeficiencyDiscrepancies`, res?.data?.getAffiliationQuestions4Details[0]?.faculty_deficiency_discrepancies);
                AffiliationQuestions4Formik?.setFieldValue(`colgHavingProfessionalCourses`, res?.data?.getAffiliationQuestions4Details[0]?.colg_having_professional_courses);
                AffiliationQuestions4Formik?.setFieldValue(`ratioProfUnivNorms`, res?.data?.getAffiliationQuestions4Details[0]?.ratio_prof_univ_norms);
                AffiliationQuestions4Formik?.setFieldValue(`actualRatioProfInTheCollege`, res?.data?.getAffiliationQuestions4Details[0]?.actual_ratio_prof_in_the_college);
                AffiliationQuestions4Formik?.setFieldValue(`colgPlacementCell`, res?.data?.getAffiliationQuestions4Details[0]?.colg_placement_cell);
                AffiliationQuestions4Formik?.setFieldValue(`colgAdeqStaffInPlacementCell`, res?.data?.getAffiliationQuestions4Details[0]?.colg_adeq_staff_in_placement_cell);
                AffiliationQuestions4Formik?.setFieldValue(`colgSubmCorpusFunds`, res?.data?.getAffiliationQuestions4Details[0]?.colg_subm_corpus_funds);
                AffiliationQuestions4Formik?.setFieldValue(`colgFdrCorpusFundsValidOndate`, res?.data?.getAffiliationQuestions4Details[0]?.colg_fdr_corpus_funds_valid_ondate);
                AffiliationQuestions4Formik?.setFieldValue(`colgAffiliaFeeDueToColg`, res?.data?.getAffiliationQuestions4Details[0]?.colg_affilia_fee_due_to_colg);
                AffiliationQuestions4Formik?.setFieldValue(`colgMaintainingHygenEnvin`, res?.data?.getAffiliationQuestions4Details[0]?.colg_maintaining_hygen_envin);
                AffiliationQuestions4Formik?.setFieldValue(`colgProvHygenDrinkingWater`, res?.data?.getAffiliationQuestions4Details[0]?.colg_prov_hygen_drinking_water);
                AffiliationQuestions4Formik?.setFieldValue(`colgProvAdequeteSafeElecEquip`, res?.data?.getAffiliationQuestions4Details[0]?.colg_prov_adequete_safe_elec_equip);
                AffiliationQuestions4Formik?.setFieldValue(`colgHasProperRoad`, res?.data?.getAffiliationQuestions4Details[0]?.colg_has_proper_road);
                AffiliationQuestions4Formik?.setFieldValue(`colgAreaIsSuitableForEduInstitu`, res?.data?.getAffiliationQuestions4Details[0]?.colg_area_is_suitable_for_edu_institu);
                AffiliationQuestions4Formik?.setFieldValue(`colgAreaEarmarkedAccessCirculationArea`, res?.data?.getAffiliationQuestions4Details[0]?.colg_area_earmarked_access_circulation_area);
                AffiliationQuestions4Formik?.setFieldValue(`colgProvOtherAment`, res?.data?.getAffiliationQuestions4Details[0]?.colg_prov_other_ament);
                AffiliationQuestions4Formik?.setFieldValue(`otherDescremencies`, res?.data?.getAffiliationQuestions4Details[0]?.other_descremencies);

            }
            else {
                console.log(" DATA NOT FOUND")
            }
        })
    }

    useEffect(() => {
        GetDeficineces();
        GetQuestionsubmited4();
        GetDeficiency4();
    }, [user_id])

    return (
        <>
            <CommonFormHeading heading="Faculty Details Section - IV" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AffiliationQuestions4Formik}>
                        <bie.Row className="px-2 pt-3 mb-3">
                            <Form onChange={AffiliationQuestions4Formik.handleChange} onSubmit={AffiliationQuestions4Formik.handleSubmit} className='affl-form'>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Faculty Details</h1></div>
                                <bie.Row className='px-2 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='field-mandatory mb-1'>Has the college has faculty as per the Educational Qualifications Norms of the University :</label>
                                        <Field as='select' name="colgFacultyEduQuali" className='form-control mb-2 '>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgFacultyEduQuali" component="div" className="text-error" />
                                    </bie.Col>


                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college has faculty as per the Experience Qualifications Norms of the University</label>
                                        <Field as='select' name="colgFaculExperQuali" className='form-control mb-2 '>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgFaculExperQuali" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college has the Faculty (Number) as per the strength and as per the Norms of the University</label>
                                        <Field as='select' name="colgHavingFacultAsPerStrength" className='form-control mb-2 '>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgHavingFacultAsPerStrength" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college has faculty for teaching all the Existing and New courses and Combinations</label>
                                        <Field as='select' name="colgHavingFacultTeachAllExisCoursesAndCombinat" className='form-control mb-2 '>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgHavingFacultTeachAllExisCoursesAndCombinat" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college has Principal as per the Educational Qualifications Norms of the University</label>
                                        <Field as='select' name="colgHasPrinciAsperQuali" className='form-control mb-2 mt-3  mt-lg-0 mt-xxl-3'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgHasPrinciAsperQuali" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory' >Please mention deficiencies/discrepancies identified</label>
                                        <Field as='textarea' name="facultyDeficiencyDiscrepancies" className='form-control mb-2 mt-lg-3 mt-xxl-3' maxLength="450" />

                                        <ErrorMessage name="facultyDeficiencyDiscrepancies" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Is the College having any Professional courses</label>
                                        <Field as='select' name="colgHavingProfessionalCourses" className='form-control mb-3 mt-3 mt-lg-4 mt-xxl-3 mt-xl-0'
                                            onChange={(e) => {
                                                AffiliationQuestions4Formik.setFieldValue("ratioProfUnivNorms", "");
                                                AffiliationQuestions4Formik.setFieldValue("actualRatioProfInTheCollege", "");

                                            }} >
                                            <option value=''>---select---</option><option value='1'>Yes</option><option value='2'>No</option>
                                        </Field>

                                        <ErrorMessage name="colgHavingProfessionalCourses" component="div" className="text-error" />
                                    </bie.Col>

                                    {AffiliationQuestions4Formik?.values?.colgHavingProfessionalCourses === "1" && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={4} className='mb-2'>
                                                <label className='mb-1 field-mandatory'>Ratio of Professors/Associate professors/Assistant Professors as per the University norms</label>
                                                <Field type="text" name="ratioProfUnivNorms" className='form-control' maxLength="8" />
                                                <ErrorMessage name="ratioProfUnivNorms" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={4} className='mb-2'>
                                                <label className='mb-1 field-mandatory'>Actual Ratio of Professors/Associate professors/Assistant Professors (Available in the college)</label>
                                                <Field type="text" name="actualRatioProfInTheCollege" className="form-control" maxLength="8" />
                                                <ErrorMessage name="actualRatioProfInTheCollege" component="div" className="text-error" />
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>

                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Other Details</h1></div>

                                <bie.Row className='px-2 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college constituted Placement cell for the students</label>
                                        <Field as='select' name="colgPlacementCell" className='form-control mb-2 mt-xxl-0 mt-lg-3 mt-xl-0'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>

                                        <ErrorMessage name="colgPlacementCell" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college deputed adequate staff in the Placement cell with the qualifications prescribed by the University</label>
                                        <Field as='select' name="colgAdeqStaffInPlacementCell" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgAdeqStaffInPlacementCell" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory' >Has the college submitted Corpus Funds as per the University Norms</label>
                                        <Field as='select' name="colgSubmCorpusFunds" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgSubmCorpusFunds" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Are the FDRs of Corpus Funds Valid as on date</label>
                                        <Field as='select' name="colgFdrCorpusFundsValidOndate" className='form-control mb-2 mt-3'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgFdrCorpusFundsValidOndate" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Total Affiliation Fee Due by the college to the University</label>
                                        <Field type='text' name="colgAffiliaFeeDueToColg" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength={10} className='form-control mt-3' />
                                        <ErrorMessage name="colgAffiliaFeeDueToColg" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory' >Is the college maintaining Hygienic environment to the students of the college</label>
                                        <Field as='select' name="colgMaintainingHygenEnvin" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgMaintainingHygenEnvin" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Is the college providing safe and hygienic drinking water to the students</label>
                                        <Field as='select' name="colgProvHygenDrinkingWater" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvHygenDrinkingWater" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college provided Adequate and safe electrical equipment in the college buildings</label>
                                        <Field as='select' name="colgProvAdequeteSafeElecEquip" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvAdequeteSafeElecEquip" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college has proper approach road</label>
                                        <Field as='select' name="colgHasProperRoad" className='form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgHasProperRoad" component="div" className="text-error" />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='field-mandatory mb-1'>Is the area in which college is being run is suitable for Educational Institutions</label>
                                        <Field as='select' name="colgAreaIsSuitableForEduInstitu" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgAreaIsSuitableForEduInstitu" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='field-mandatory mb-1'>Is Area earmarked for Access & Circulation Area is as per the Norms of the University as per the University Norms</label>
                                        <Field as='select' name="colgAreaEarmarkedAccessCirculationArea" className='form-control mb-2 mt-3'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgAreaEarmarkedAccessCirculationArea" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='field-mandatory mb-1'>Has the college provided other Amenities as per the University Affiliation Norms</label>
                                        <Field as='select' name="colgProvOtherAment" className='form-control mb-2 mt-xxl-0 mt-lg-3 mt-xl-0'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvOtherAment" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Please mention deficiencies /discrepancies identified</label>
                                        <Field as="textarea" name="otherDescremencies" className="form-control mt-3 mb-2" maxLength="450" />
                                        <ErrorMessage name="otherDescremencies" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                                {tabledata?.length > 0 ? (<>
                                    <div className='table-responsive'>
                                        <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table">
                                            <thead>
                                                <tr style={{ height: "50px", fontSize: "16px" }} >
                                                    <th>S.No</th>
                                                    <th>List of Deficiencies</th>
                                                    <th>FFCA Status Of Deficiency</th>
                                                    <th>FFCA Deficiency Remarks</th>
                                                </tr>

                                            </thead>
                                            <tbody>
                                                {tabledata?.map((dd, index) => (
                                                    <tr key={index}>
                                                        <td> <center>{index + 1}</center></td>
                                                        <td className='text-left'>{dd.description}</td>
                                                        <td>
                                                            <div style={{ position: 'relative' }}>

                                                                <Field type='hidden' name={`defCdc[${index}].slNo`} className='form-control' />

                                                                <Field as='select' name={`defCdc[${index}].ffcaStatusOfDeficiency`} className='form-control'>
                                                                    <option value=''>--SELECT--</option>
                                                                    <option value='Fully Compiled'>Fully Compiled</option>
                                                                    <option value='Partially Compiled'>Partially Compiled</option>
                                                                    <option value='Not Compiled'>Not Compiled</option>
                                                                </Field>
                                                                <ErrorMessage name={`defCdc[${index}].ffcaStatusOfDeficiency`} className='text-error' component='div' />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Field as='textarea' name={`defCdc[${index}].ffcaDeficiencyRemarks`} className='form-control' maxLength="450" />
                                                            <ErrorMessage name={`defCdc[${index}].ffcaDeficiencyRemarks`} className='text-error' component='div' />

                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    </div>
                                </>) : null}
                                <div className="pt-1 mb-5">
                                    <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2  '>Submit</button>
                                </div>
                            </Form>
                        </bie.Row>

                    </FormikProvider>
                </bie.Container>
            </bie.Container >
        </>)
}
